module.exports = __webpack_public_path__ + "static/media/livedooh-dev-webhooks-2.024ad333.svg";